import axios, {AxiosRequestConfig} from 'axios';
import {environment} from "../environment";

export default class Service {
    api = environment().api;

    axiosRequestConfig: AxiosRequestConfig = {
        responseType: "json",
    };

    getCustomer(id: string) {
        return axios.get(`${this.api}/customer/get/${id}`);
    }

    addCustomer(data) {
        return axios.post(`${this.api}/customer/add`, data, this.axiosRequestConfig);
    }

    updateCustomer(data) {
        return axios.post(`${this.api}/customer/update`, data, this.axiosRequestConfig);
    }

    getQuestions() {
        return axios.get(`${this.api}/question/getAll`);
    }

    hasBeenFinished(mobile) {
        return axios.get(`${this.api}/customer/hasBeenFinished/${mobile}`);
    }

    getCustomerQuestion(id: string) {
        return axios.get(`${this.api}/customerQuestion/get/${id}`);
    }

    addCustomerQuestion(data) {
        return axios.post(`${this.api}/customerQuestion/add`, data, this.axiosRequestConfig);
    }

    newTest(data) {
        return axios.post(`${this.api}/customer/newTest`, data, this.axiosRequestConfig);
    }

    updateCustomerQuestion(data) {
        return axios.post(`${this.api}/customerQuestion/update`, data, this.axiosRequestConfig);
    }
}
